<template>
  <div class="modal-overlay" v-if="visible" @click.self="closeModal">
    <div class="modal-content">
      <h3>Acceso con contraseña</h3>
      <p>Ingrese la contraseña para acceder al sitio durante el mantenimiento</p>
      
      <div class="form-group">
        <input 
          type="password" 
          v-model="password" 
          placeholder="Contraseña" 
          class="form-control"
          @keyup.enter="validatePassword"
        />
      </div>
      
      <div class="error-message" v-if="error">
        {{ error }}
      </div>
      
      <div class="modal-actions">
        <button class="btn btn-secondary" @click="closeModal">Cancelar</button>
        <button 
          class="btn btn-primary" 
          @click="validatePassword"
          :disabled="loading"
        >
          <span v-if="loading" class="spinner"></span>
          <span v-else>Verificar</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import maintenanceService from '@/services/maintenanceService';

export default {
  name: 'BypassPasswordModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      password: '',
      error: null,
      loading: false,
      failedAttempts: 0
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
      // Reset state after closing
      this.password = '';
      this.error = null;
    },
    async validatePassword() {
      if (!this.password) {
        this.error = 'Por favor ingrese una contraseña';
        return;
      }
      
      this.loading = true;
      this.error = null;
      
      try {
        // Pasar duración de validez de 12 horas (puede configurarse)
        const response = await maintenanceService.validateBypassPassword(this.password, 12);
        
        if (response.valid) {
          console.log(`Contraseña de bypass validada correctamente. Válida hasta: ${response.expiryTime}`);
          this.$emit('access-granted', {
            validUntil: response.expiryTime
          });
          this.closeModal();
        } else {
          this.error = response.message || 'Contraseña incorrecta';
          
          // Incrementar contador de intentos fallidos
          this.failedAttempts = (this.failedAttempts || 0) + 1;
          
          // Si hay demasiados intentos fallidos (5+), agregar un pequeño retraso
          if (this.failedAttempts >= 5) {
            await new Promise(resolve => setTimeout(resolve, 1500));
          }
        }
      } catch (err) {
        this.error = 'Error al validar la contraseña';
        console.error('Error validating bypass password:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: var(--black-color-3);
  border-radius: 8px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
}

h3 {
  color: var(--white-color);
  margin-bottom: 1rem;
}

p {
  color: var(--white-color-2);
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  background-color: var(--black-color-2);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  color: var(--white-color);
  font-size: 1rem;
}

.form-control:focus {
  border-color: var(--primary-color);
  outline: none;
}

.error-message {
  color: #ff4d4f;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.btn {
  padding: 0.6rem 1.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
}

.btn-primary {
  background-color: var(--primary-color);
  color: var(--white-color);
  border: none;
}

.btn-primary:hover {
  background-color: var(--primary-color-dark);
}

.btn-secondary {
  background-color: transparent;
  color: var(--white-color-2);
  border: 1px solid var(--border-color);
}

.btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>